import { useState } from 'react';
import { DateRange } from 'react-day-picker';
import { useAuthState } from 'react-firebase-hooks/auth';

import SessionsTable from '@/components/SessionsTable/SessionsTable';
import { Text } from '@/components/shared/Text/Text';
import { fbAuth } from '@/lib/firebase/init';
import WithLoading from '@/lib/hoc/WithLoading/WithLoading';
import { SessionStatus } from '@/lib/types/session-status';
import { countSessionsByType } from '@/lib/utils/sessions';
import { SessionHub } from '@addmile/backend-client';

import { useCoachByEmail } from '../hooks/useCoachByEmail';
import { useCoachSessions } from '../hooks/useCoachSessions';
import CoachInfo from './components/CoachInfo/CoachInfo';

const CoachCabinet = () => {
  const [dateRange, setDateRange] = useState<DateRange>({ from: undefined, to: undefined });
  const [fbUser] = useAuthState(fbAuth);
  const email = fbUser?.email;

  const { data: coachData, isLoading: isCoachLoading } = useCoachByEmail(email);
  const { data: sessions = [], isLoading: isSessionsLoading } = useCoachSessions(
    coachData ? [coachData.id] : [],
    dateRange,
  );

  const handleExternalFilterChange = ({ dateRange }: { dateRange?: DateRange }) => {
    if (dateRange !== undefined) {
      setDateRange(dateRange);
    }
  };

  const sessionsByType = countSessionsByType(sessions, SessionStatus);
  const isLoading = isCoachLoading || isSessionsLoading;

  return (
    <WithLoading isLoading={isLoading}>
      <Text.H2>My Cabinet</Text.H2>
      <CoachInfo coachData={coachData} sessions={sessionsByType} />

      <SessionsTable
        sessions={sessions.filter((session: SessionHub) => session.status !== SessionStatus.New)}
        externalFilter={{ dateRange: dateRange }}
        setExternalFilter={handleExternalFilterChange}
        isLoading={isSessionsLoading}
        isCoachView
      />
    </WithLoading>
  );
};

export default CoachCabinet;
